import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { createSearchParams, useNavigate } from 'react-router-dom';
import AppConfig from '../../config';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import TypesService from '../../services/TypesService';
import { appSlice } from '../../store/slices';
import IconAML from '../IconAML/IconAML';
import ListItem from '../ListItem';
import './AddressItem.scss';

const { routes } = AppConfig;

const ICON_SIZE = 20;

const CurrenciesById = TypesService.CurrenciesById;
const BlockchainsById = TypesService.BlockchainsById;

const AddressItem = ({ className = '', address, lastItem = false, onClick = () => {} }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const currencyData = CurrenciesById[address.CurrencyId];

	const onSelect = () => onClick(address);

	const openLearnAboutAmlRiskModal = () => {
		dispatch(
			appSlice.actions.addModal({
				isHeaderWithColorBgAndIcon: true,
				title: t('Unchecked risk'),
				subtitle: t('Why this address has no AML result yet'),
				headerBackgroundColor: '#828892',
				headerIcon: 'DefaultAML',
				tag: 'LearnAboutAmlRisk',
				isOpen: true,
				height: '65%',
				outsideParams: { address: address.Address },
			})
		);
	};

	const { riskStatus } = HelperService.getAmlRiskByText(
		address.RiskScore,
		address.IsActualAml,
		BlockchainsById[address.BlockchainId].network,
		false
	);

	const amlIconClick = e => {
		e.stopPropagation();

		if (riskStatus.unchecked) {
			openLearnAboutAmlRiskModal();
			return;
		}

		navigate({
			pathname: routes.addressAmlDetails,
			search: createSearchParams({ currencyId: address.CurrencyId, address: address.Address }).toString(),
		});
	};

	const dontShowAmount = address.Amount === undefined || address.Amount === null;
	const dontShowAmountUsd = address.AmountUsd === undefined || address.AmountUsd === null;

	return (
		<ListItem
			className={'AddressItem ' + className}
			icon={
				<div onClick={amlIconClick}>
					<IconAML
						percent={address?.RiskScore}
						isActualAML={address?.IsActualAml}
						blockchainId={address?.BlockchainId}
						checkDate={address?.LastCheckDate}
					/>
				</div>
			}
			iconSize='medium'
			title={address.AddressLabel}
			description={
				dontShowAmount && dontShowAmountUsd ? address.Address : HelperService.middleEllipsis(address.Address)
			}
			rightTitle={
				!dontShowAmount && HelperService.FormatCrypto(address.Amount, currencyData.Precision) + ' ' + currencyData.Name
			}
			rightDescription={!dontShowAmountUsd && '$' + HelperService.FormatFiatWithoutCurrency(address.AmountUsd)}
			bottomSeparator={!lastItem}
			onSelect={onSelect}
		/>
	);
};

AddressItem.propTypes = {
	className: PropTypes.string,
	address: PropTypes.object,
	lastItem: PropTypes.bool,
	onClick: PropTypes.func,
};

export default AddressItem;
